import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, useHistory, Route } from "react-router-dom";
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import * as view from '../views';
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import { createBrowserHistory } from 'history';
import { onPreRegister } from "../services";
import { onJustReducerUpdate } from "../redux/action";
import { useDispatch } from "react-redux";
import { CLIENT_ID } from "../redux/action_type";

export const history = createBrowserHistory();

function ScrollToTop() {
    const history = useHistory()
    const dispatch = useDispatch()

    useEffect(() => {
        const fpPromise = FingerprintJS.load()
        fpPromise
            .then(fp => fp.get())
            .then(result => {
                const visitorId = result.visitorId
                const payload = {
                    'client_id': visitorId,
                }
                const storageValue = localStorage.getItem("clientID") || ""
                if (!storageValue) {
                    onPreRegister(payload).then((response) => {
                        if (response.data.code === 200) {
                            localStorage.setItem("clientID", JSON.stringify(response.data.data))
                            dispatch(onJustReducerUpdate(response.data.data, CLIENT_ID))
                        }
                    })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            })
    }, [history])
    useEffect(() => {
        const unlisten = history.listen((location, action) => {
            if (action !== 'POP') {
                window.scrollTo(0, 0)
            }
        })
        return () => unlisten()
    }, [history])
    return (null)
}
const AppRouter = () => {
    return (
        <Router basename="/">
            <ScrollToTop />
            <Switch>
                {/* <PublicRoute exact={true} path={"/"} component={view.Login} /> */}
                <PrivateRoute exact={true} path={"/campaign-invites"} component={view.Home} />
                <PrivateRoute exact={true} path={"/account-authentication"} component={view.AccountLink} />
                <PublicRoute exact={true} path={"/"} component={view.LinkAccountNew} />
                <PrivateRoute exact={true} path={"/dashboards"} component={view.Dashboard} />
                <PrivateRoute exact={true} path={"/social-performance"} component={view.SocialPerformance} />
                <PublicRoute exact={true} path={"/media-kit/:id"} component={view.socialPerformanceReport} />
                <Route exact path="/dashboard" name="Signup Page" component={view.LinkAccount} />
                {/* <PublicRoute exact={true} path={"/link-account-new"} component={view.LinkAccountNew} /> */}

                {/* Sprint 4 Routers */}
                <PrivateRoute exact={true} path={"/onboarding"} component={view.Onboarding} />
                <PrivateRoute exact={true} path={"/store-preview"} component={view.StorePreview} />
                <PrivateRoute exact={true} path="/affiliate-dashboard" component={view.AffiliateDashboard} />
                <PrivateRoute exact={true} path={"/kyc_info"} component={view.KycInfo}/>
                <PrivateRoute exact={true} path={"/store-online"} component={view.StoreOnline} />
                <PublicRoute exact={true} path={"/creator-form"} component={view.publicCreatorForm} />
                <PublicRoute exact={true} path={"/creator-landing"} component={view.CreatorLandingPage} />
                <PublicRoute exact={true} path={"/:id"} component={view.ConsumerView} />
            </Switch>
        </Router>
    );
};

export default AppRouter;
